import React from "react";
import WeightRoom from "./weight-room/weight-room";

export default function WeightRoomTab() {
  return <WeightRoom />;
}
